import React, { useState, useEffect, useContext } from "react";
import { getGroupManage } from "../Messages/MessageService";
import { TostMsg } from "../../../App";
import { messageDelete } from "../Messages/MessageService";
import { UpdateOwner } from "../Messages/MessageService";
import AccountSetting from "./AccountSetting";
import ConfigurationSetting from "./ConfigurationSetting";
import MessageGroupSetting from "./MessageGroupSetting";
import OrgLeaveSetting from "./OrgLeaveSetting";
import OrgDepartmentCategory from "./OrgDepartmentCategory";
import OrgDesignationSetting from "./OrgDesignationSetting";
import EmployeeRequestCategory from "./EmployeeRequestCategory";
import EmployeeRequestSeverity from "./EmployeeRequestSeverity";
import EmployeeRequestPriority from "./EmployeeRequestPriority";
import EmployeeRequestStatus from "./EmployeeRequestStatus";
import EmployeeRequestSubCategory from "./EmployeeRequestSubCategory";
import EmployeeRequestDefaultAssignment from "./EmployeeRequestDefaultAssignment";
import EmployeeRequestAccess from "./EmployeeRequestAccess";
import EmployeeRequestDefaultNotification from "./EmployeeRequestDefaultNotification";
import OrgWfhSetting from "./OrgWfhSetting";
import OrgPolicyCategorys from "./OrgPolicyCategorys";
import OrgLocationSetting from "./OrgLocationSetting";
import OrgAppLink from "./OrgAppLink";
import OrgBadgeSetting from "./OrgBadgesSetting";
import OrgAwardSetting from "./OrgAwardSetting";
import DeleteAccountSetting from "./DeleteAccountSetting";
import SubscriptionSetting from "./SubscriptionSetting";
import NotificationSetting from "./NotificationSetting";
import OrgBranchSetting from "./OrgBranchSetting";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import OrgSystemAlert from "./OrgSystemAlert";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
function AdvanceSetting() {
  const { SettingName } = useParams();
  const history = useHistory();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const rowsPerPage = 10;
  const [groupManageList, setGroupManageList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  useEffect(() => {
    setTimeout(() => {
      if (SettingName) {
        changeOrganizationSetting(SettingName);
      } else {
        changeOrganizationSetting("account");
      }
    }, 100);
    GetGroupManage();
  }, []);

  async function GetGroupManage() {
    setIsloading(true);
    const params = {
      OrgId: userDetails?.OrgId,
    };
    try {
      const response = await getGroupManage(params);
      setGroupManageList(response?.Data?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const changeOrganizationSetting = (settingName) => {
    const selector = settingClickMap[settingName];
    if (selector) {
      document.querySelector(selector)?.click();
    } else {
      console.warn(`No click action defined for setting: ${settingName}`);
    }
  };

  const settingClickMap = {
    account: "#v-pills-home-tab",
    Configuration: "#v-pills-confi-tab ",
    AwardTypes: "#v-pills-orgaward-tab ",
    LeaveTypes: "#v-pills-orgleave-tab ",
    WFHType: "#v-pills-orgwfhleave-tab ",
    LocationType: "#v-pills-orglocation-tab",
    PolicyCategory: "#v-pills-orgpolicy-tab",
    AppLinks: "#v-pills-orgapi-tab",
    Badges: "#v-pills-orgbadges-tab ",
    Departments: "#v-pills-orgdepart-tab ",
    Designation: "#v-pills-orgdesignation-tab ",
    RequestCategory: "#v-pills-employeerequest-tab ",
    RequestPriority: "#v-pills-employeerequestpriority-tab ",
    RequestSeverity: "#v-pills-employeerequestseverity-tab ",

    RequestStatus: "#v-pills-employeerequeststatus-tab ",
    RequestSubCategory: "#v-pills-employeerequestsubCat-tab ",
    RequestDefault: "#v-pills-employeerequestdefault-tab ",
    RequestAccess: "#v-pills-employeerequestaccess-tab",
    RequestDefaultNotification: "#v-pills-employeenotification-tab",

    SystemAlerts: "#v-pills-systemAlert-tab ",
    MessageGroups: "#v-pills-grpmanage-tab ",
    Notification: "#v-pills-messages-tab ",
    Subscription: "#v-pills-profile-tab ",
  };

  const DeleteGroupManage = (GroupId) => {
    const params = {
      Id: GroupId,
    };
    try {
      if (GroupId) {
        messageDelete(params);
        toster.current.success("Group is deleted");
        GetGroupManage();
      }
    } catch (error) {
      console.error("Error in DeleteGroupManage:", error);
    }
  };

  const ChangeOwner = (GroupId, OwnerId) => {
    const params = {
      GroupId: GroupId,
      OwnerId: OwnerId,
    };
    try {
      if ((GroupId, OwnerId)) {
        UpdateOwner(params);
        toster.current.success("Owner Change Successfully!!");
        GetGroupManage();
      }
    } catch (error) {
      console.error("Error in OwnerChange", error);
    }
  };

  const changeTabRouting = (SettingName) => {
    changeOrganizationSetting(SettingName);
    history.push(`/OrgSetting/${SettingName}`);
  };

  return (
    <div>
      <div className="container-fluid bg-white">
        <div className="row justify-content-center">
          <div className="onboarding-screen">
            <div className="row">
              <div className="col-xl-12">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="remain-option mt-0">
                      <h2>General Settings</h2>

                      <div className="dashboard-title font-w600 mb-0">
                        <p>{userDetails.OrganizationName} </p>
                      </div>
                      <div className="advance-settings">
                        <div className="set-width">
                          <div
                            className="nav flex-column nav-pills"
                            role="tablist"
                            aria-orientation="vertical"
                          >
                            <button
                              className="nav-link active"
                              id="v-pills-home-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-home"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-home"
                              aria-selected="true"
                              onClick={() => changeTabRouting("account")}
                            >
                              <img src="/images/setting/menu/account.svg" />
                              <div>
                                <p>Organization Details</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-confi-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-confi"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-confi"
                              aria-selected="true"
                              onClick={() => changeTabRouting("Configuration")}
                            >
                              <img src="/images/setting/menu/account.svg" />
                              <div>
                                <p>Configuration</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-orgaward-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-orgaward"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-orgaward"
                              aria-selected="false"
                              onClick={() => changeTabRouting("AwardTypes")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Award Types</p>
                              </div>
                            </button>

                            <button
                              className="nav-link"
                              id="v-pills-orgleave-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-orgleave"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-orgleave"
                              aria-selected="false"
                              onClick={() => changeTabRouting("LeaveTypes")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Leave Types</p>
                              </div>
                            </button>

                            <button
                              className="nav-link"
                              id="v-pills-orgwfhleave-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-orgwfhleave"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-orgwfhleave"
                              aria-selected="false"
                              onClick={() => changeTabRouting("WFHType")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>WFH Types</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-orglocation-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-orglocation"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-orglocation"
                              aria-selected="false"
                              onClick={() => changeTabRouting("LocationType")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Location Types</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-orgpolicy-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-orgpolicy"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-orgpolicy"
                              aria-selected="false"
                              onClick={() => changeTabRouting("PolicyCategory")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p> Policy Category</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-orgapi-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-orgapi"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-orgapi"
                              aria-selected="false"
                              onClick={() => changeTabRouting("AppLinks")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p> App Links</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-orgbadges-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-orgbadges"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-orgbadges"
                              aria-selected="false"
                              onClick={() => changeTabRouting("Badges")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p> Badges</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-orgdepart-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-orgdepart"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-orgdepart"
                              aria-selected="false"
                              onClick={() => changeTabRouting("Departments")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p> Departments</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-orgdesignation-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-orgdesignation"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-orgdesignation"
                              aria-selected="false"
                              onClick={() => changeTabRouting("Designation")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Designations</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-employeerequest-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-employeerequest"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-employeerequest"
                              aria-selected="false"
                              onClick={() =>
                                changeTabRouting("RequestCategory")
                              }
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Employee Request Category</p>
                              </div>
                            </button>

                            <button
                              className="nav-link"
                              id="v-pills-employeerequestpriority-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-employeerequestpriority"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-employeerequestpriority"
                              aria-selected="false"
                              onClick={() =>
                                changeTabRouting("RequestPriority")
                              }
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Employee Request Priority</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-employeerequestseverity-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-employeerequestseverity"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-employeerequestseverity"
                              aria-selected="false"
                              onClick={() =>
                                changeTabRouting("RequestSeverity")
                              }
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Employee Request Severity</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-employeerequeststatus-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-employeerequeststatus"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-employeerequeststatus"
                              aria-selected="false"
                              onClick={() => changeTabRouting("RequestStatus")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Employee Request Status</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-employeerequestsubCat-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-employeerequestsubCat"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-employeerequestsubCat"
                              aria-selected="false"
                              onClick={() =>
                                changeTabRouting("RequestSubCategory")
                              }
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Employee Request Sub Category</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-employeerequestdefault-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-employeerequestdefault"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-employeerequestdefault"
                              aria-selected="false"
                              onClick={() => changeTabRouting("RequestDefault")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Employee Request Default Assignment</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-employeerequestaccess-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-employeerequestaccess"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-employeerequestaccess"
                              aria-selected="false"
                              onClick={() => changeTabRouting("RequestAccess")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Employee Request Access</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-employeenotification-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-employeenotification"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-employeenotification"
                              aria-selected="false"
                              onClick={() =>
                                changeTabRouting("RequestDefaultNotification")
                              }
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Employee Request Default Notification</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-systemAlert-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-systemAlert"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-systemAlert"
                              aria-selected="false"
                              onClick={() => changeTabRouting("SystemAlerts")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>System Alerts</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-grpmanage-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-grpmanage"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-grpmanage"
                              aria-selected="false"
                              onClick={() => changeTabRouting("MessageGroups")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Message Groups</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-messages-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-messages"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-messages"
                              aria-selected="false"
                              onClick={() => changeTabRouting("Notification")}
                            >
                              <img src="/images/setting/menu/notification.svg" />
                              <div>
                                <p>Notification</p>
                              </div>
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-profile-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-profile"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-profile"
                              aria-selected="false"
                              onClick={() => changeTabRouting("Subscription")}
                            >
                              {/* onClick={() => changeTabRouting("Subscription")} */}
                              <img src="/images/setting/menu/plan.svg" />
                              <div>
                                <p>Subscription</p>
                              </div>
                            </button>
                          </div>
                          <div className="tab-content" id="v-pills-tabContent">
                            <div
                              className="tab-pane fade show active"
                              id="v-pills-home"
                              role="tabpanel"
                              aria-labelledby="v-pills-home-tab"
                            >
                              <AccountSetting />
                            </div>
                            <div
                              className="tab-pane fade"
                              id="v-pills-confi"
                              role="tabpanel"
                              aria-labelledby="v-pills-confi-tab"
                            >
                              <ConfigurationSetting />
                            </div>
                            <div
                              className="tab-pane fade"
                              id="v-pills-orgaward"
                              role="tabpanel"
                              aria-labelledby="v-pills-orgaward-tab"
                            >
                              <OrgAwardSetting />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-orgleave"
                              role="tabpanel"
                              aria-labelledby="v-pills-orgleave-tab"
                            >
                              <OrgLeaveSetting />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-orgwfhleave"
                              role="tabpanel"
                              aria-labelledby="v-pills-orgwfhleave-tab"
                            >
                              <OrgWfhSetting />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-orglocation"
                              role="tabpanel"
                              aria-labelledby="v-pills-orglocation-tab"
                            >
                              <OrgLocationSetting />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-orgpolicy"
                              role="tabpanel"
                              aria-labelledby="v-pills-orgpolicy-tab"
                            >
                              <OrgPolicyCategorys />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-orgapi"
                              role="tabpanel"
                              aria-labelledby="v-pills-orgapi-tab"
                            >
                              <OrgAppLink />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-orgbadges"
                              role="tabpanel"
                              aria-labelledby="v-pills-orgbadges-tab"
                            >
                              <OrgBadgeSetting />
                            </div>
                            <div
                              className="tab-pane fade"
                              id="v-pills-orgbranches"
                              role="tabpanel"
                              aria-labelledby="v-pills-orgbranches-tab"
                            >
                              <OrgBranchSetting />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-orgdepart"
                              role="tabpanel"
                              aria-labelledby="v-pills-orgdepart-tab"
                            >
                              <OrgDepartmentCategory />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-orgdesignation"
                              role="tabpanel"
                              aria-labelledby="v-pills-orgdesignation-tab"
                            >
                              <OrgDesignationSetting />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-employeerequest"
                              role="tabpanel"
                              aria-labelledby="v-pills-employeerequest-tab"
                            >
                              <EmployeeRequestCategory />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-employeerequestpriority"
                              role="tabpanel"
                              aria-labelledby="v-pills-employeerequestpriority-tab"
                            >
                              <EmployeeRequestPriority />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-employeerequestseverity"
                              role="tabpanel"
                              aria-labelledby="v-pills-employeerequestseverity-tab"
                            >
                              <EmployeeRequestSeverity />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-employeerequeststatus"
                              role="tabpanel"
                              aria-labelledby="v-pills-employeerequeststatus-tab"
                            >
                              <EmployeeRequestStatus />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-employeerequestsubCat"
                              role="tabpanel"
                              aria-labelledby="v-pills-employeerequestsubCat-tab"
                            >
                              <EmployeeRequestSubCategory />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-employeerequestdefault"
                              role="tabpanel"
                              aria-labelledby="v-pills-employeerequestdefault-tab"
                            >
                              <EmployeeRequestDefaultAssignment />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-employeerequestaccess"
                              role="tabpanel"
                              aria-labelledby="v-pills-employeerequestaccess-tab"
                            >
                              <EmployeeRequestAccess />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-employeenotification"
                              role="tabpanel"
                              aria-labelledby="v-pills-employeenotification-tab"
                            >
                              <EmployeeRequestDefaultNotification />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-systemAlert"
                              role="tabpanel"
                              aria-labelledby="v-pills-systemAlert-tab"
                            >
                              <OrgSystemAlert />
                            </div>

                            <div
                              className="tab-pane fade"
                              id="v-pills-grpmanage"
                              role="tabpanel"
                              aria-labelledby="v-pills-grpmanage-tab"
                            >
                              <MessageGroupSetting />
                            </div>
                            <div
                              className="tab-pane fade"
                              id="v-pills-profile"
                              role="tabpanel"
                              aria-labelledby="v-pills-profile-tab"
                            >
                              <SubscriptionSetting />
                            </div>
                            <div
                              className="tab-pane fade"
                              id="v-pills-messages"
                              role="tabpanel"
                              aria-labelledby="v-pills-messages-tab"
                            >
                              <NotificationSetting />
                            </div>
                            <div
                              className="tab-pane fade"
                              id="v-pills-settings"
                              role="tabpanel"
                              aria-labelledby="v-pills-settings-tab"
                            >
                              <DeleteAccountSetting />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdvanceSetting;
